// extracted by mini-css-extract-plugin
module.exports = {"saveForm":"UDykMOHDWo_qjs_5aaxk1","activo":"_2VCSX-v5eTVi5bp15Zt3I1"};